exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/src/app/writing/writing.component.css
// module id = ../../../../../src/app/writing/writing.component.css
// module chunks = 0